import { useEffect, useState, useCallback } from "react";
import { fetchClassGroups } from "../../Classes/api/classesApi";

// All classes scheduled for the day/campus — INCLUDING empty ones — so the
// morning lane can show classes with no students yet, not just those people are
// grouped into. The morning timetable endpoint only returns people, so empty
// classes are invisible without this. Shape per class: { id, groupName,
// leaderName, groupDates }.
export default function useMorningClasses(date, campus) {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    if (!date || !campus) {
      setClasses([]);
      return;
    }
    setLoading(true);
    try {
      const data = await fetchClassGroups(campus, date, date);
      const list = Array.isArray(data) ? data : [];
      setClasses(
        list.filter((c) =>
          Array.isArray(c.groupDates) ? c.groupDates.includes(date) : true
        )
      );
    } catch {
      setClasses([]);
    } finally {
      setLoading(false);
    }
  }, [date, campus]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { classes, loading, refresh: fetchData };
}
